/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Otp_Btn_VerifyingInputs */

const es_ab_otp_btn_verifying = /** @type {(inputs: Ab_Otp_Btn_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando…`)
};

const gl_ab_otp_btn_verifying = /** @type {(inputs: Ab_Otp_Btn_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando…`)
};

const en_ab_otp_btn_verifying = /** @type {(inputs: Ab_Otp_Btn_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying…`)
};

/**
* | output |
* | --- |
* | "Verifying…" |
*
* @param {Ab_Otp_Btn_VerifyingInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_otp_btn_verifying = /** @type {((inputs?: Ab_Otp_Btn_VerifyingInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Otp_Btn_VerifyingInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_otp_btn_verifying(inputs)
	if (locale === "en") return en_ab_otp_btn_verifying(inputs)
	return es_ab_otp_btn_verifying(inputs)
});